import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const MarkEmptyIcon = memo(() => (
  <IconWrapper>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16">
      <path
        fill="currentColor"
        fillRule="evenodd"
        // eslint-disable-next-line max-len
        d="m6.05 1.35.3.95A5.74 5.74 0 0 1 8.2 2V1a6.255 6.255 0 0 0-2.15.35ZM2.55 3.9a7.35 7.35 0 0 1 1.5-1.55l.6.8a6.63 6.63 0 0 0-1.3 1.35l-.8-.6Zm-1 1.95.95.3A5.74 5.74 0 0 0 2.2 8h-1c-.01-.732.109-1.46.35-2.15Zm0 4.35a7.2 7.2 0 0 0 1 1.95l.8-.6A6.445 6.445 0 0 1 2.5 9.9l-.95.3Zm4.5 4.45a7.2 7.2 0 0 1-1.95-1l.6-.8a6.443 6.443 0 0 0 1.65.85l-.3.95Zm7.8-2.55a7.593 7.593 0 0 1-1.55 1.55l-.6-.8a5.765 5.765 0 0 0 1.35-1.35l.8.6Zm.05-2.25.95.3c.218-.697.336-1.42.35-2.15h-1a5.74 5.74 0 0 1-.3 1.85Zm-.1-6a7.2 7.2 0 0 1 1 1.95l-.95.3A6.443 6.443 0 0 0 13 4.45l.8-.6ZM12.25 2.3a7.2 7.2 0 0 0-1.95-1l-.3.95a6.445 6.445 0 0 1 1.65.85l.6-.8Zm-2.2 11.4.3.95c-.703.189-1.423.306-2.15.35v-1a5.74 5.74 0 0 0 1.85-.3Z"
        clipRule="evenodd"
      />
    </svg>
  </IconWrapper>
));
